import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-secondary mb-6">About Uni9ja Media Hub</h1>

        <section className="bg-surface rounded-xl shadow-sm p-6 mb-8">
          <h2 className="text-xl font-semibold text-primary mb-3">About Us</h2>
          <p className="text-text leading-relaxed">
            Uni9ja Media Hub is where young creatives in University On The Niger and beyond come to be informed, create, and make impact. We are building a community where ideas turn into opportunities through content, contests, and collaboration. It’s a space to express yourself, grow your skills, and connect with people of like minds.
          </p>
          <p className="text-text leading-relaxed mt-3">
            We are more than just a media, we’re about real impact supporting each other, giving back, and creating something bigger than ourselves.
          </p>
          <p className="font-semibold text-primary mt-3">This is where Creativity Meets Purpose. This is Uni9ja Media Hub.</p>
        </section>

        <section className="bg-surface rounded-xl shadow-sm p-6 mb-8">
          <h2 className="text-xl font-semibold text-primary mb-3">Our Vision</h2>
          <p className="text-text leading-relaxed">
            To build a globally trusted media and creative platform where young people become informed, inspired to create, and empowered to grow fostering a culture of innovation, meaningful engagement through contests, and collective impact through community and charitable initiatives.
          </p>
        </section>

        <section className="bg-surface rounded-xl shadow-sm p-6">
          <h2 className="text-xl font-semibold text-primary mb-4">Frequently Asked Questions</h2>
          <div className="space-y-4">
            <div><h3 className="font-semibold text-secondary">1. What is Uni9ja Media?</h3><p className="text-text-light text-sm">Uni9ja Media is a digital community platform that shares Nigerian university news, events, and student experiences while promoting creativity, entertainment, and academic excellence.</p></div>
            <div><h3 className="font-semibold text-secondary">2. Who can join Uni9ja Media?</h3><p className="text-text-light text-sm">Any student or young creative across Nigerian universities and beyond can be part of the community.</p></div>
            <div><h3 className="font-semibold text-secondary">3. What kind of content is shared on Uni9ja Media?</h3><p className="text-text-light text-sm">We share university news, campus activities, academic insights, student achievements, creative content, and community updates.</p></div>
            <div><h3 className="font-semibold text-secondary">4. How can I participate in Uni9ja Media activities?</h3><p className="text-text-light text-sm">You can participate by engaging with posts, joining discussions, submitting content, or taking part in programs and contests.</p></div>
            <div><h3 className="font-semibold text-secondary">5. What is the goal of Uni9ja Media?</h3><p className="text-text-light text-sm">Our goal is to inform, inspire, and connect students while building a supportive and creative community.</p></div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;